import { Input } from "@/src/components/universalInput";
import { Task } from "@/src/data/allTypes";
import { useState } from "react";

export function UniqueTaskForm({
  current,
  onChange,
}: {
  current?: Task;
  onChange: (newValue: Task) => void;
}) {
  let [data, setData] = useState(current || ({} as Task));
  function setNewValue(newValue: Task) {
    setData({ ...newValue });
    onChange(newValue);
  }

  return (
    <div className="grid c1 gap20">
      <Input
        name="Posologie"
        value={data?.posology}
        type="text"
        onChange={(newValue) => {
          data.posology = newValue;
          setNewValue(data);
        }}
      />
      <Input
        name="Notes (optionnel)"
        value={data?.notes}
        rows={6}
        type="textarea"
        onChange={(newValue) => {
          data.notes = newValue;
          setNewValue(data);
        }}
      />
    </div>
  );
}
